/**
 * Cart Quantity Limit Warning Component
 * Shows a warning message when fabric swatch total cart quantity exceeds max_count
 * Identifies fabric swatches based on variant metafield: netsuite.is_fabric_swatch
 */

class CartQuantityLimitWarning extends HTMLElement {
  constructor() {
    super();

    const max_count = this.getAttribute('data-max-swatch-count');

    this.checkAndUpdateWarning(max_count);
  }

  connectedCallback() {
    // Subscribe to cart updates
    // eslint-disable-next-line no-undef
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      const max_count = this.getAttribute('data-max-swatch-count');
      this.checkAndUpdateWarning(max_count);
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  // Helper function to parse cart-metafields section HTML and extract fabric swatch items
  parseSwatchMetafields(rawSectionHtml) {
    const metafieldsByKey = new Map();
    if (!rawSectionHtml) return metafieldsByKey;

    try {
      // Extract JSON from section HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(rawSectionHtml, 'text/html');
      const jsonText = doc.body.textContent || doc.body.innerText || '';
      const data = JSON.parse(jsonText.trim());
      
      (data.items || []).forEach((entry) => {
        if (entry.is_fabric_swatch) {
          metafieldsByKey.set(entry.key, { name: entry.name });
        }
      });
    } catch (err) {
      console.error('Failed to parse swatch metafields', err);
    }

    return metafieldsByKey;
  }

  checkAndUpdateWarning(max_count) {
    // Fetch both cart data and metafields section
    Promise.all([
      // eslint-disable-next-line no-undef
      fetch('/cart.js', fetchConfig('javascript')),
      fetch(`${window.location.pathname}?sections=cart-metafields`)
    ])
      .then(([cartResponse, metafieldsResponse]) => Promise.all([
        cartResponse.json(),
        metafieldsResponse.json().catch(() => ({}))
      ]))
      .then(([cart, sectionsData]) => {
        const totalQuantity = parseInt(max_count, 10);

        // Parse metafields to identify fabric swatches
        const swatchMetafields = this.parseSwatchMetafields(sectionsData['cart-metafields']);

        // Count total quantity of fabric swatch items
        let swatch_count = 0;
        cart.items.forEach(item => {
          if (swatchMetafields.has(item.key)) {
            swatch_count = swatch_count + item.quantity;
          }
        });

        if (swatch_count < totalQuantity) {
          this.classList.add('swatch_limit_hidden');
        } else {
          this.classList.remove('swatch_limit_hidden');

          // Filter fabric swatch items and calculate updates to enforce limit
          let counter = 0;
          const updates = {};
          cart.items.forEach(item => {
            if (swatchMetafields.has(item.key)) {
              counter = counter + item.quantity;
              if (totalQuantity < counter) {
                let num = Number(item.quantity) - Number(counter) + Number(totalQuantity);
                updates[item.key] = num < 0 ? 0 : num;
              }
            }
          });
    
       // console.log(updates);
            removeExtraSwatch(cart,updates);


      
function removeExtraSwatch(cart,updates) { 
      try {
      async function getswatchCart() {
      //console.log(updates);
    // 3. Send update request to clear those items if any match
      if (Object.keys(updates).length > 0) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        
        // 4. Reload page or update cart drawer DOM
       // window.location.reload();
       await window.cartDrawerDOMUpdater.updateCartDrawer();
      }
      }
      getswatchCart();
      }
    catch (err) {
      console.error('Failed to remove items by product type', err);
    }
}

        }
      })
      .catch((error) => {
        console.error('Error checking cart quantity:', error);
      });
  }
}

customElements.define('cart-quantity-limit-warning', CartQuantityLimitWarning);